import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Experience You Can Count On
          </h2>
          <div className="space-y-6 text-lg text-gray-600 leading-relaxed">
            <p>
              ATW Against the Wind Moving Services is a fully licensed and insured moving company dedicated to making
              your relocation smooth, safe, and stress-free. With years of experience serving families and businesses
              across the United States, we've built our reputation on professionalism, accountability, and genuine care
              for your belongings.
            </p>
            <p>
              Our trained crews undergo rigorous background checks and continuous training to ensure every move meets our
              high standards. When you choose ATW, you're choosing a partner committed to protecting what matters most
              to you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;